import React from "react";
import {
    Menu,
    Bell,
    Search,
    ChevronDown,
} from "lucide-react";

function Header({ setMobileOpen }) {

    const user =
        localStorage.getItem("jodiPointUser") ||
        "Administrator";

    return (
        <header className="admin-header">

            <div className="header-left">

                <button
                    className="mobile-menu-button"
                    onClick={() => setMobileOpen(true)}
                >
                    <Menu size={23} />
                </button>

                <div className="header-search">

                    <Search size={18} />

                    <input
                        type="text"
                        placeholder="Search..."
                    />

                </div>

            </div>

            <div className="header-right">

                <button className="notification-button">
                    <Bell size={20} />

                    <span className="notification-dot" />
                </button>

                <div className="header-user">

                    <div className="user-avatar">
                        {user.charAt(0).toUpperCase()}
                    </div>

                    <div className="user-details">
                        <strong>{user}</strong>

                        <span>
                            Administrator
                        </span>
                    </div>

                    <ChevronDown size={16} />

                </div>

            </div>

        </header>
    );
}

export default Header;